import { DocumentSummaryController } from './documentSummary.controller';
import template from './documentSummary.html';

export const documentSummaryComponent = {
  name: 'documentSummaryComponent',
  restrict: 'E',
  template,
  controller: DocumentSummaryController,
  controllerAs: 'vm',
  bindings: {
    documents: '<',
    ticket: '<'
  }
};
